var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "9.375rem",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135 29",
    style: {
      enableBackground: "new 0 0 135 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.style0{fill:#FFFFFF;}\n\t.style1{fill:url(#SVGID_1_);}\n\t.style2{fill:#FFC200;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M37.3,14.1L33.2,4h1.9l2.4,6L40,3.8l2.6,6.3l2.3-6h1.9l-4.1,10.1L40,7.6L37.3,14.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M55.7,13.7h-1.9l-1-2.1h-4.1l-1,2.1h-1.9l4.9-10.1L55.7,13.7z M49.3,10.3h2.8l-1.4-3L49.3,10.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M58.7,13.7h-1.8V4h2.7c2.1,0,3.7,1.1,3.7,3c0,1.3-0.7,2.2-1.9,2.7l3,4h-2.1L59.5,10h-0.9L58.7,13.7z     M58.7,8.6h0.9c1.1,0,1.8-0.5,1.8-1.5c0-1-0.7-1.5-1.8-1.5h-0.9V8.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M86.8,13.7H85V4h2.7c2.1,0,3.7,1.1,3.7,3c0,1.3-0.7,2.2-1.9,2.7l3,4h-2.1L87.6,10h-0.9L86.8,13.7z M86.8,8.6    h0.9c1.1,0,1.8-0.5,1.8-1.5c0-1-0.7-1.5-1.8-1.5h-0.9V8.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M72.8,4h1.8v10.1l-6.8-6.6v6.2H66V3.7l6.8,6.6V4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M76.9,4h6v1.5h-4.2V8h3.9v1.5h-3.9v2.7h4.3v1.5h-6V4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M97.3,4h2.8c2.2,0,3.3,1,3.3,2.6c0,1-0.6,1.7-1.3,2c1.1,0.3,2,1.1,2,2.4c0,1.7-1.3,2.8-3.4,2.8h-3.3V4z     M100,8.1c1,0,1.6-0.4,1.6-1.3S101,5.5,100,5.5H99v2.6L100,8.1L100,8.1z M100.4,12.3c1,0,1.7-0.5,1.7-1.4s-0.7-1.4-1.7-1.4H99v2.8    H100.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M107.6,13.7h-1.8V4h2.7c2.1,0,3.7,1.1,3.7,3c0,1.3-0.7,2.2-1.9,2.7l3,4h-2.1l-2.8-3.8h-0.9L107.6,13.7z     M107.6,8.6h0.9c1.1,0,1.8-0.5,1.8-1.5c0-1-0.7-1.5-1.8-1.5h-0.9V8.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M123.9,8.9c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5C121.6,3.9,123.9,6.1,123.9,8.9z M115.7,8.9    c0,1.9,1.4,3.4,3.2,3.4c1.8,0,3.2-1.4,3.2-3.4c0-1.9-1.4-3.4-3.2-3.4C117.1,5.5,115.7,7,115.7,8.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M128.1,12.4c1,0,1.7-0.4,1.7-1.2c0-0.6-0.4-0.9-1-1.2l-1.6-0.8c-1.1-0.5-1.9-1.1-1.9-2.5    c0-1.7,1.4-2.8,3.2-2.8c1.1,0,2.1,0.5,2.6,1v1.9c-0.7-0.7-1.7-1.3-2.7-1.3c-0.8,0-1.4,0.4-1.4,1.1c0,0.5,0.4,0.8,0.9,1.1l1.5,0.7    c1.4,0.7,2.2,1.3,2.2,2.7c0,1.8-1.5,2.9-3.4,2.9c-1.2,0-2.3-0.5-3-1v-1.8C125.9,11.8,127,12.4,128.1,12.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M134.9,12.7c0,0.6-0.5,1.1-1.1,1.1h0c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h0    C134.4,11.6,134.9,12.1,134.9,12.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M95.6,26.7h-1.8V17h2.7c2.1,0,3.7,1.1,3.7,3c0,1.3-0.7,2.2-1.9,2.7l3,4h-2.1L96.4,23h-0.9L95.6,26.7z     M95.6,21.6h0.9c1.1,0,1.8-0.5,1.8-1.5c0-1-0.7-1.5-1.8-1.5h-0.9V21.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M85.6,17h6v1.5h-4.2V21h3.9v1.5h-3.9v2.7h4.3v1.5h-6L85.6,17L85.6,17z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M74.3,21.9c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5s2.2-5,5-5C72.1,16.9,74.3,19.1,74.3,21.9z M66.2,21.9    c0,1.9,1.4,3.4,3.2,3.4c1.8,0,3.2-1.4,3.2-3.4c0-1.9-1.4-3.4-3.2-3.4C67.6,18.5,66.2,20,66.2,21.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M37.3,17c2.8,0,5,2.1,5,4.9s-2.2,4.9-5,4.9h-3V17H37.3z M36.1,18.5v6.7h1.1c2,0,3.3-1.5,3.3-3.4    s-1.3-3.4-3.3-3.4L36.1,18.5L36.1,18.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M46,17v9.7h-1.8V17H46z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M50.8,25.4c1,0,1.7-0.4,1.7-1.2c0-0.6-0.4-0.9-1-1.2l-1.6-0.8c-1.1-0.5-1.9-1.1-1.9-2.5    c0-1.7,1.4-2.8,3.2-2.8c1.1,0,2.1,0.5,2.6,1v1.9C52.9,19,52,18.4,51,18.4c-0.8,0-1.4,0.4-1.4,1.1c0,0.5,0.4,0.8,0.9,1.1l1.5,0.7    c1.4,0.7,2.2,1.3,2.2,2.7c0,1.8-1.5,2.9-3.4,2.9c-1.2,0-2.3-0.5-3-1v-1.8C48.6,24.8,49.7,25.4,50.8,25.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M63,24.1v2.1c-0.7,0.4-1.6,0.7-2.5,0.7c-2.8,0-5-2.2-5-5s2.2-5,5-5c0.9,0,1.8,0.2,2.5,0.7v2.1    c-0.6-0.6-1.5-1-2.5-1c-1.8,0-3.2,1.4-3.2,3.3c0,1.9,1.4,3.3,3.2,3.3C61.6,25.2,62.4,24.8,63,24.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M74.5,17h2l3,6.5l3-6.5h1.9l-4.9,10.1L74.5,17z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "style0",
    d: "M104.6,26.7v-4.4L101,17h2l2.5,3.7L108,17h2l-3.6,5.4v4.4H104.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.8216,
    y1: 15.5196,
    x2: 26.6042,
    y2: 15.5196,
    gradientTransform: "matrix(1 0 0 -1 0 30)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4047FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#04006C"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "style1",
    d: "M26.6,9.8c-0.2,1.3-0.8,5.5-3.9,9.6c-3.1,4.3-7.3,6.3-8.5,7c-1.2-0.6-5.4-2.7-8.5-7C2.6,15.3,2,11.1,1.8,9.8    l1.9-1V7.4l1.9-1V5c2.6-1.2,5.4-2,8.7-2.5C17.5,3,20.3,3.8,22.9,5v1.4l1.9,1v1.4L26.6,9.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "style2",
    d: "M26.4,7.8V6.4l-1.9-1V3.9l-0.9-0.4c-2.7-1.3-5.7-2.1-9.2-2.6l-0.2,0l-0.2,0c-3.5,0.5-6.5,1.3-9.2,2.6L3.9,4    v1.5L2,6.4v1.4L0,8.9L0.2,10c0.5,3.9,2,7.4,4.2,10.4c2.3,3.1,5.3,5.6,9.1,7.5l0.7,0.4l0.7-0.4c3.8-1.9,6.8-4.4,9.1-7.5    c2.2-3,3.7-6.5,4.2-10.4l0.2-1.1L26.4,7.8z M26.6,9.8c-0.2,1.3-0.8,5.5-3.9,9.6c-3.1,4.3-7.3,6.3-8.5,7c-1.2-0.6-5.4-2.7-8.5-7    C2.6,15.3,2,11.1,1.8,9.8l1.9-1V7.4l1.9-1V5c2.6-1.2,5.4-2,8.7-2.5C17.5,3,20.3,3.8,22.9,5v1.4l1.9,1v1.4L26.6,9.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "style2",
    d: "M11.4,5.9l0.1,11.3l-0.1,0c-1.2-3-1.9-6.8-2.1-10.6c-0.6,0.3-1.2,0.6-1.9,1c0.3,3.4,0.9,6.5,1.9,9.3l-0.6,0.3    c-1.6-2.2-2.6-4.9-3.3-8.1c-0.5,0.4-1,0.9-1.5,1.5c0.9,3.8,2.4,6.8,4.5,9.2l1.6-1c0.8,1.7,2,3.4,3.2,4.7V5.6    C12.7,5.6,12.1,5.7,11.4,5.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "style2",
    d: "M22.1,11.7c0.7-0.7,0.8-1.3,0.8-1.9c0-0.9-0.8-1.8-1.9-2.5c-0.7-0.4-1.7-0.9-3.2-1.4    c-0.9-0.2-1.8-0.4-2.7-0.4v18c3.8-1.9,8.3-7.3,8.3-10C23.4,12.7,23,12.2,22.1,11.7z M17,7.7c0.9,0,3.9,0.9,3.9,2.2    c0,0.4-0.4,1.1-1.6,1.7L17,12.8V7.7z M19.3,17.7c-0.5,0.6-1.4,1.6-2.3,2.3v-5.1c0,0,3.4-1.9,3.5-2c1,0.3,1,1,1,1.1    C21.5,14.8,20.5,16.3,19.3,17.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.d82d87d3867252215b6efa186f61cb54.svg";
export { ForwardRef as ReactComponent };